import React, { useEffect, useRef, useState } from "react";
import { saveSettings } from "../../redux/actions/Settings/saveSettingAction";
import { saveNotificationSettings } from "../../redux/actions/Settings/saveNotificationSettingAction";
import { setTheme } from "../../functions/themeService/themeService";
import { useDispatch, useSelector } from "react-redux";
import AiMessageModalComponent from "../aiMessageModal/AiMessageModal";
import { setAiAssistant } from "../../redux/actions/setAiAssistantAction";
import dayjs from "dayjs";
import { useIsMobile as useIsMobileHook } from "../../hooks/useIsMobile";
import { Capacitor } from '@capacitor/core';
import { EdgeToEdge } from '@capawesome/capacitor-android-edge-to-edge-support';
import { StatusBar, Style } from '@capacitor/status-bar';
import CalendarSettings from "./CalendarSettings";
import { getLatestTaskListNoCache } from "../../redux/actions/Firebase/getLatestTaskListNoCache";

const SettingsModal = (props) => {
    const { onOpen, onClose } = props;
    const [selectedTab, setSelectedTab] = useState(0);
    const [selectedTabText, setSelectedTabText] = useState("General");
    const [showSync, setShowSync] = useState(false);
    const modalRef = useRef();
    const dispatch = useDispatch();
    const isMobile = useIsMobileHook();
    const isNativePlatform = Capacitor.isNativePlatform();
    const [theme, setSettingTheme] = useState('light');
    const appTheme = useSelector((state) => state.userSettings.theme)
    const defaultView = useSelector((state) => state.userSettings.defaultView);
    const notifications = useSelector((state) => state.notificationSettings.active);
    const aiAssistant = useSelector((state) => state.userSettings.aiAssistant);
    const zoomLevel = useSelector((state) => state.userSettings.zoomLevel);
    const showDueDate = useSelector((state) => state.userSettings.showDueDate);
    const showTaskProgress = useSelector((state) => state.userSettings.showTaskProgress);
    const showVisualSize = useSelector((state) => state.userSettings.showVisualSize);
    const showCalendar = useSelector((state) => state.showCalendarPage);
    const [showAiMessageModal, setShowAiMessageModal] = useState(false);
    const versionRef = useRef();

    const handleSelectedTab = (tab) => {
        switch (tab) {
            case 0:
                setSelectedTabText("General");
                break;
            case 1:
                setSelectedTabText("Task Appearance");
                break;
            case 2:
                setSelectedTabText("Calendar");
                break;
            case 3:
                setSelectedTabText("About");
                break;
        }
        setSelectedTab(tab);
    };

    const handleRemoveAccount = () => {
        window.open('https://docs.google.com/forms/d/e/1FAIpQLSfOrIvBVaQo9BBg50t7j8XeDdLda8QQV_KJ14Pl22cnOa8rTg/viewform', '_blank', 'noopener,noreferrer');
    }

    const handleTandCPolicy = () => {
        window.open('https://docs.google.com/document/d/e/2PACX-1vQs0IpVlELlsMXeXDvdgd9uuy88D4sg_sLIIMccCwGMn18-Ca0RtLG3-prkBULsyrh0tf7sv-Z6a_l-/pub', '_blank', 'noopener,noreferrer');
    };

    const handlePrivacyPolicy = () => {
        window.open('https://docs.google.com/document/d/e/2PACX-1vSkQf1wYMi6HyIDhZPJUXwmoQMubP7EgaQfjt57xtpK9a7F7GUYyXRz12Zx8pkwqA/pub', '_blank', 'noopener,noreferrer');
    };

    const handleThemeChange = (event) => {

        setTheme(event.target.value);

        const json = {
            theme: event.target.value,
            defaultView: defaultView,
            aiAssistant: aiAssistant,
            zoomLevel: zoomLevel,
            showDueDate: showDueDate,
            showTaskProgress: showTaskProgress,
            showVisualSize: showVisualSize
        };
        dispatch(saveSettings(json));

        if (Capacitor.getPlatform() === 'android') {
            if (json.theme === 'light') {
                EdgeToEdge.setBackgroundColor({ color: '#ffffff' });
                StatusBar.setStyle({ style: Style.Light });
            }
            else {
                EdgeToEdge.setBackgroundColor({ color: '#2A3953' });
                StatusBar.setStyle({ style: Style.Dark });
            }
        }

        setSettingTheme(event.target.value);


    };
    const handleDefaultViewChange = (event) => {

        const json = {
            defaultView: event.target.value,
            theme: theme,
            aiAssistant: aiAssistant,
            zoomLevel: zoomLevel,
            showDueDate: showDueDate,
            showTaskProgress: showTaskProgress,
            showVisualSize: showVisualSize
        };
        dispatch(saveSettings(json));
    };
    const handleNotificationsChange = (event) => {
        dispatch({ type: 'SET_NOTIFICATION_ACTIVE', payload: { active: event.target.checked } });

        const json = {
            active: event.target.checked
        };

        dispatch(saveNotificationSettings(json));
    };

    const handleAiAssistantChange = (event) => {

        if (event.target.checked) {
            setShowAiMessageModal(true);
        } else {

            dispatch(setAiAssistant(false));

            const json = {
                aiAssistant: event.target.checked.toString(),
                theme: theme,
                defaultView: defaultView,
                zoomLevel: zoomLevel,
                showDueDate: showDueDate,
                showTaskProgress: showTaskProgress,
                showVisualSize: showVisualSize
            };
            dispatch(saveSettings(json));
        }
    };

    const handleShowDueDateChange = (event) => {

        dispatch({ type: 'SET_SHOW_DUEDATE', payload: { showDueDate: event.target.checked } });

        const json = {
            aiAssistant: aiAssistant,
            theme: theme,
            defaultView: defaultView,
            zoomLevel: zoomLevel,
            showDueDate: event.target.checked.toString(),
            showTaskProgress: showTaskProgress,
            showVisualSize: showVisualSize
        };
        dispatch(saveSettings(json));

    };

    const handleShowTaskProgressChange = (event) => {

        dispatch({ type: 'SET_SHOW_TASK_PROGRESS', payload: { showTaskProgress: event.target.checked } });

        const json = {
            aiAssistant: aiAssistant,
            theme: theme,
            defaultView: defaultView,
            zoomLevel: zoomLevel,
            showDueDate: showDueDate,
            showTaskProgress: event.target.checked.toString(),
            showVisualSize: showVisualSize
        };
        dispatch(saveSettings(json));

    };

    const handleSync = () => {
        dispatch(getLatestTaskListNoCache());

        onClose();
    };

    const handleShowVisualSizeChange = (event) => {

        dispatch({ type: 'SET_SHOW_VISUALSIZE', payload: { showVisualSize: event.target.checked } });

        const json = {
            aiAssistant: aiAssistant,
            theme: theme,
            defaultView: defaultView,
            zoomLevel: zoomLevel,
            showDueDate: showDueDate,
            showTaskProgress: showTaskProgress,
            showVisualSize: event.target.checked.toString()
        };

        dispatch(saveSettings(json));

    };

    const showCalendarMenu = () => {
        let showCalendarMenu = useSelector((state) => state.showCalendarPage);

        if (showCalendarMenu) {
            if (useIsMobileHook()) {
                return false;
            }
        }
        return showCalendarMenu;
    };


    const closeAcceptAiMessageModal = () => {
        setShowAiMessageModal(false);
    };

    const closeRejectAiMessageModal = () => {
        setShowAiMessageModal(false);
    };

    useEffect(() => {
        const handleKeyDown = (event) => {
            if (event.shiftKey && event.key === 'S' && versionRef.current?.matches(':hover')) {
                setShowSync(true);
            }
        };

        const handleMouseLeave = () => {
            setShowButton(false); // Hide button if mouse leaves label
        };

        window.addEventListener('keydown', handleKeyDown);
        if (versionRef.current) {
            versionRef.current.addEventListener('mouseleave', handleMouseLeave);
        }

        return () => {
            window.removeEventListener('keydown', handleKeyDown);
            if (versionRef.current) {
                versionRef.current.removeEventListener('mouseleave', handleMouseLeave);
            }
        };
    }, []);

    useEffect(() => {
        const handleModalAndTheme = async () => {
            if (onOpen) {
                modalRef.current?.showModal();
            } else {
                modalRef.current?.close();
            }

            setSettingTheme(appTheme);

            setShowSync(false);
        };

        handleModalAndTheme();
    }, [onOpen]);
    return (
        <dialog className="gt-modal gt-modal--settings" ref={modalRef}>
            <section className="gw-settings th-gt"
                style={{ height: 'auto' }}          >
                <div className="gw-settings-pane">
                    <div className="gw-settings-pane__left">
                        <div className="gw-settings-nav-area">
                            <ul className="gw-list-group gw-settings-nav-area__menu">
                                <li className="gw-list-group__item">
                                    {selectedTab === 0 ? (<button className="gw-settings-menu-button gw-settings-menu-button--selected"
                                        onClick={() => { handleSelectedTab(0) }}>General</button>) :
                                        (<button className="gw-settings-menu-button"
                                            onClick={() => { handleSelectedTab(0) }}>General</button>)}
                                </li>
                                <li className="gw-list-group__item">
                                    {selectedTab === 1 ? (<button className="gw-settings-menu-button gw-settings-menu-button--selected"
                                        onClick={() => { handleSelectedTab(1) }}>Task Appearance</button>) :
                                        (<button className="gw-settings-menu-button"
                                            onClick={() => { handleSelectedTab(1) }}>Task Appearance</button>)}
                                </li>
                                {showCalendarMenu() && (
                                    <li className="gw-list-group__item">
                                        {selectedTab === 2 ? (<button className="gw-settings-menu-button gw-settings-menu-button--selected"
                                            onClick={() => { handleSelectedTab(2) }}>Calendar</button>) :
                                            (<button className="gw-settings-menu-button"
                                                onClick={() => { handleSelectedTab(2) }}>Calendar</button>)}
                                    </li>
                                )}
                                <li className="gw-list-group__item">
                                    {selectedTab === 3 ? (<button className="gw-settings-menu-button gw-settings-menu-button--selected"
                                        onClick={() => { handleSelectedTab(3) }}>About</button>) :
                                        (<button className="gw-settings-menu-button"
                                            onClick={() => { handleSelectedTab(3) }}>About</button>)}
                                </li>
                            </ul>
                            <div className="gw-settings-nav-area__branding">
                                <svg className="gw-settings-logo">
                                    <use
                                        className="gt-logo--light"
                                        xlinkHref="#globaltasks-svg-logo"
                                    ></use>
                                    <use
                                        className="gt-logo--dark"
                                        xlinkHref="#globaltasks-svg-logo-dark"
                                    ></use>
                                </svg>
                            </div>
                        </div>
                    </div>
                    <div className="gw-settings-pane__right">
                        <div className="gw-settings-main">
                            <div className="gw-settings-main__header gw-settings-main-header">
                                <div className="gw-group gw-group--space-between">
                                    <div className="gw-settings-main-header__left">
                                        <div className="gw-settings-pane-settings-title">
                                            <div className="gw-group gw-group--space-between">
                                                <svg className="gw-settings-pane-settings-title__icon">
                                                    <use xlinkHref="#globaltasks-svg-settings"></use>
                                                </svg>
                                                <h4 className="gw-settings-pane-settings-title__text">
                                                    {selectedTabText}
                                                </h4>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="gw-settings-main-header__right">
                                        <button
                                            aria-label="maximise"
                                            className="gw-icon-button gw-icon-button--icon"
                                            onClick={() => {
                                                onClose();
                                            }}
                                        >
                                            <i className="gw-icon-button__icon gw-button__icon--close"></i>
                                        </button>
                                    </div>
                                </div>
                            </div>
                            {selectedTab === 0 && (<div className="gw-settings-main__body gw-settings-body">
                                <div className="gw-settings-body__row">
                                    <div className="gw-settings-field">
                                        <label className="gw-settings-field__label" htmlFor="theme">
                                            Theme
                                        </label>
                                        <select
                                            className="gw-select"
                                            id="theme"
                                            value={theme}
                                            onChange={handleThemeChange}
                                        >
                                            <option value="light">Light</option>
                                            <option value="dark">Dark</option>
                                        </select>
                                    </div>
                                </div>
                                <div className="gw-settings-body__row">
                                    <div className="gw-settings-field">
                                        <label className="gw-settings-field__label" htmlFor="defaultView">
                                            Startup page
                                        </label>
                                        <select
                                            className="gw-select"
                                            id="defaultView"
                                            value={defaultView}
                                            onChange={handleDefaultViewChange}
                                        >
                                            <option value="overview">Overview</option>
                                            {/*<option value="calendar">Calendar</option>*/}
                                            <option value="todo">To-do</option>
                                            <option value="dueDates">Due Dates</option>
                                        </select>
                                    </div>
                                </div>
                                <div className="gw-settings-body__row">
                                    <div className="gw-checkbox">
                                        <input type="checkbox" className="gw-checkbox__input" id="notifications-label" name="notifications"
                                            checked={notifications}
                                            onChange={handleNotificationsChange} />
                                        <label className="gw-checkbox__input-label" htmlFor="notifications-label">
                                            Notifications
                                        </label>
                                    </div>
                                </div>
                                <div className="gw-settings-body__row">
                                    <div className="gw-checkbox">
                                        <input type="checkbox" className="gw-checkbox__input" id="assistant-label" name="assistant"
                                            checked={aiAssistant}
                                            onChange={handleAiAssistantChange} />
                                        <label className="gw-checkbox__input-label" htmlFor="assistant-label">
                                            Smart task assistant
                                        </label>
                                        <p style={{ fontSize: '10px' }}>
                                            The assistant feature uses AI and related technologies. This requires us to send some information about your task to third parties. You can opt out of using this feature here.
                                        </p>
                                    </div>
                                </div>
                            </div>)}
                            {selectedTab === 1 && (<div className="gw-settings-main__body gw-settings-body">
                                <div className="gt-task">
                                    <div className="gt-task__color" style={{ background: '#80C3E9' }} ></div>
                                    <input className="gt-task__completed" type="checkbox" aria-label="Task completed?" />
                                    <p className="gt-task__title">Your task will appear like this</p>
                                    <div className="gt-context-menu-activator gt-context-menu-activator--bottom-right">

                                        <button className="gw-icon-button gw-icon-button--icon" aria-label="more">
                                            <i className="gw-icon-button__icon gw-button__icon--more"></i>
                                        </button>
                                    </div>
                                    <div className="gt-task__tags">
                                        {showDueDate && (
                                            <div className="gt-task-tag">
                                                <svg xmlns="http://www.w3.org/2000/svg"><use href="#globaltasks-svg-calendar"></use></svg>
                                                <p>{dayjs().format('ll')}</p>
                                            </div>)}
                                        {showTaskProgress && (
                                            <div className="gt-task-tag" >
                                                <svg xmlns="http://www.w3.org/2000/svg"><use href="#globaltasks-svg-checklist"></use></svg>
                                                <p>1/4</p>
                                            </div>)}
                                        {showVisualSize && (
                                            <div className="gt-task-tag gt-task-tag--align-right">
                                                <svg xmlns="http://www.w3.org/2000/svg"><use href="#globaltasks-svg-effort-medium"></use></svg>
                                            </div>)}
                                    </div>
                                </div>
                                <div className="gw-settings-body__row">
                                    <label className="gw-settings-field__label" htmlFor="taskLabels">
                                        Task labels
                                    </label>
                                    <div className="gw-checkbox">
                                        <input type="checkbox" className="gw-checkbox__input" id="showDueDate-label" name="showDueDate"
                                            checked={showDueDate}
                                            onChange={handleShowDueDateChange} />
                                        <label className="gw-checkbox__input-label" htmlFor="showDueDate-label">
                                            Show due date
                                        </label>
                                    </div>
                                </div>
                                <div className="gw-settings-body__row">
                                    <div className="gw-checkbox">
                                        <input type="checkbox" className="gw-checkbox__input" id="showTaskProgress-label" name="showTaskProgress"
                                            checked={showTaskProgress}
                                            onChange={handleShowTaskProgressChange} />
                                        <label className="gw-checkbox__input-label" htmlFor="showTaskProgress-label">
                                            Show task progress
                                        </label>
                                    </div>
                                </div>
                                <div className="gw-settings-body__row">
                                    <div className="gw-checkbox">
                                        <input type="checkbox" className="gw-checkbox__input" id="showTaskSize-label" name="showTaskSize"
                                            checked={showVisualSize}
                                            onChange={handleShowVisualSizeChange} />
                                        <label className="gw-checkbox__input-label" htmlFor="showTaskSize-label">
                                            Show effort
                                        </label>
                                    </div>
                                </div>
                            </div>)}
                            {selectedTab === 2 && (<CalendarSettings onClose={onClose}>

                            </CalendarSettings>)}
                            {selectedTab === 3 && (<div className="gw-settings-main__body gw-settings-body">
                                <p ref={versionRef} >Global Tasks™</p>
                                <p>Version: {import.meta.env.VITE_PUBLIC_APP_VERSION}</p>
                                {showSync && (
                                    <p style={{ fontSize: '10px' }}><button className="gw-button gw-button--primary" aria-label="Sync Tasks"
                                        onClick={() => { handleSync() }}>
                                        Retrieve tasks
                                    </button>
                                        <p>Warning: Retrieving tasks may result in loss of tasks. This feature shouldn't be used unless advised to by Everway Technical Support.</p>
                                    </p>)}
                                {/*<p>Licensing information or expiry date?</p>*/}
                                {/*<p>Any copyright information for external dependancies</p>*/}
                                <div className="gw-settings-body__button-area">
                                    <div className="gw-group gw-group--align-right">
                                        <small>Copyright © 2025 Everway Opco Ltd</small> |
                                        <button className="gw-button gw-link gw-button--link gw-button--link--small"
                                            onClick={() => { handleTandCPolicy(); }}>
                                            User Terms
                                        </button> |
                                        <button className="gw-button gw-link gw-button--link gw-button--link--small"
                                            onClick={() => { handlePrivacyPolicy(); }}>
                                            Privacy Policy
                                        </button>
                                        {isNativePlatform && (
                                            <button className="gw-button gw-link gw-button--link gw-button--link--small"
                                                onClick={() => { handleRemoveAccount(); }}>
                                                Delete account?
                                            </button>)}
                                    </div>
                                </div>
                            </div>)}
                        </div>
                    </div>
                </div>
            </section>
            <AiMessageModalComponent
                modalOpen={showAiMessageModal}
                onCloseAccept={closeAcceptAiMessageModal}
                onCloseReject={closeRejectAiMessageModal}
            ></AiMessageModalComponent>
        </dialog>
    );
};

export default SettingsModal;
